export const toPng = (canvas: HTMLCanvasElement[], opt) => {
  return canvas.map(c => c.toDataURL('image/png', 1.0)).map(image => ({ image, ...opt }));
};
